import React, { useRef } from 'react';
import StanCard from './StanCard';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';
import slika6 from '../assets/slika6.jpg';
import slika7 from '../assets/slika7.jpeg';
import slika8 from '../assets/slika8.jpeg';

const Stanovi = ({ scrollToHome, onStanClick }) => {
  const stanoviRef = useRef(null);

  const stanoviData = [
    {
      id: 1,
      title: 'Novi Sad, Bulevar Evrope 20',
      location: 'Novi Sad, Bulevar Evrope 20',
      price: 270,
      area: 23,
      rooms: 0.5,
      type: 'Garsonjera',
      date: '19/08/24',
      images: [slika1, slika2, slika3],
      sifra: 'A50-1478',
      kupatila: 1,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 1,
      namestenost: 'Namešten',
      drzava: 'Srbija',     // Dodajemo državu
      grad: 'Novi Sad',     // Dodajemo grad
      transakcija: 'Izdavanje', // Tip transakcije
    },
    {
      id: 2,
      title: 'Novi Sad, Novo Naselje 30',
      location: 'Novi Sad, Novo Naselje 30',
      price: 450,
      area: 40,
      rooms: 1.5,
      type: 'Stan',
      date: '19/08/24',
      images: [slika5, slika6, slika4],
      sifra: 'A50-1480',
      kupatila: 1,
      parking: true,
      namena: 'Prodaja',
      garaza: 'Da',
      spratovi: 2,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Prodaja',
    },
    {
      id: 3,
      title: 'Beograd, Zemun 15',
      location: 'Beograd, Zemun 15',
      price: 680,
      area: 60,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      images: [slika7, slika8, slika3],
      sifra: 'A50-1490',
      kupatila: 2,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 1,
      namestenost: 'Prazan',
      drzava: 'Srbija',
      grad: 'Beograd',
      transakcija: 'Izdavanje',
    },
    {
      id: 4,
      title: 'Novi Sad, Liman 2',
      location: 'Novi Sad, Liman 2',
      price: 320,
      area: 30,
      rooms: 1,
      type: 'Garsonjera',
      date: '19/08/24',
      images: [slika2, slika5, slika4],
      sifra: 'A50-1500',
      kupatila: 1,
      parking: false,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 5,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
    },
    {
      id: 5,
      title: 'Novi Sad, Grbavica 45',
      location: 'Novi Sad, Grbavica 45',
      price: 590,
      area: 45,
      rooms: 1.5,
      type: 'Stan',
      date: '19/08/24',
      images: [slika3, slika8, slika1],
      sifra: 'A50-1505',
      kupatila: 1,
      parking: true,
      namena: 'Prodaja',
      garaza: 'Da',
      spratovi: 2,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Prodaja',
    },
    {
      id: 6,
      title: 'Niš, Centar 8',
      location: 'Niš, Centar 8',
      price: 420,
      area: 40,
      rooms: 1,
      type: 'Stan',
      date: '19/08/24',
      images: [slika6, slika4, slika5],
      sifra: 'A50-1600',
      kupatila: 1,
      parking: false,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 3,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Niš',
      transakcija: 'Izdavanje',
    },
    {
      id: 7,
      title: 'Kragujevac, Stanovi 3',
      location: 'Kragujevac, Stanovi 3',
      price: 750,
      area: 75,
      rooms: 3,
      type: 'Stan',
      date: '19/08/24',
      images: [slika8, slika7, slika6],
      sifra: 'A50-1650',
      kupatila: 2,
      parking: true,
      namena: 'Prodaja',
      garaza: 'Da',
      spratovi: 2,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Kragujevac',
      transakcija: 'Prodaja',
    },  {id: 8,
    title: 'Novi Sad, Bulevar Evrope 20',
    location: 'Novi Sad, Bulevar Evrope 20',
    price: 270,
    area: 23,
    rooms: 0.5,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika1, slika2, slika3],
    sifra: 'A50-1478',
    kupatila: 1,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Namešten',
    drzava: 'Srbija',     // Dodajemo državu
    grad: 'Novi Sad',     // Dodajemo grad
    transakcija: 'Izdavanje', // Tip transakcije
  },
  {
    id: 9,
    title: 'Novi Sad, Novo Naselje 30',
    location: 'Novi Sad, Novo Naselje 30',
    price: 450,
    area: 40,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika5, slika6, slika4],
    sifra: 'A50-1480',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  {
    id: 10,
    title: 'Beograd, Zemun 15',
    location: 'Beograd, Zemun 15',
    price: 680,
    area: 60,
    rooms: 2,
    type: 'Stan',
    date: '19/08/24',
    images: [slika7, slika8, slika3],
    sifra: 'A50-1490',
    kupatila: 2,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Prazan',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Izdavanje',
  },
  {
    id: 11,
    title: 'Novi Sad, Liman 2',
    location: 'Novi Sad, Liman 2',
    price: 320,
    area: 30,
    rooms: 1,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika2, slika5, slika4],
    sifra: 'A50-1500',
    kupatila: 1,
    parking: false,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 5,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Izdavanje',
  },
  {
    id: 12,
    title: 'Novi Sad, Grbavica 45',
    location: 'Novi Sad, Grbavica 45',
    price: 590,
    area: 45,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika3, slika8, slika1],
    sifra: 'A50-1505',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  ];

  const handleStanClick = (stan) => {
    onStanClick(stan);  // Prosleđujemo ceo stan iz ove komponente
  };

  return (
    <section ref={stanoviRef} className="w-full h-auto bg-gray-900 text-gray-900 overflow-hidden pt-24">
      {/* Naslov sekcije, centriran na malim ekranima i poravnat levo na većim ekranima */}
      <h2 className="text-2xl text-pink-500 font-bold text-center md:text-left mt-8 mb-8 ml-0 md:ml-28">
        Najpopularnije za iznajmljivanje
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mr-8 ml-8">
        {stanoviData.map((stan) => (
          <StanCard
            key={stan.id}  // Koristimo ID kao ključ
            title={stan.title}
            location={stan.location}
            price={stan.price}
            area={stan.area}
            rooms={stan.rooms}
            type={stan.type}
            date={stan.date}
            images={stan.images}
            onClick={() => handleStanClick(stan)}  // Prosleđujemo ceo stan
          />
        ))}
      </div>
      
      <div className="text-center mt-8">
        <button
          onClick={scrollToHome}
          className="bg-pink-700 text-white py-3 px-6 rounded-full hover:bg-pink-800 hover:text-black transition-colors duration-300 mb-8 shadow-md hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)] transform hover:scale-105 text-sm font-medium"
        >
          Početna
        </button>
      </div>
    </section>
  );
};

export default Stanovi;